import React from "react";
import { Inbox, SearchX, AlertTriangle } from "lucide-react";
import "../CustomTheme/customTheme.css";
import "./CustomEmptyState.css";

const PRESETS = {
  empty: { icon: Inbox, title: "No records found", description: "There's nothing to show here yet." },
  search: {
    icon: SearchX,
    title: "No matching results",
    description: "Try a different search or clear the filters.",
  },
  error: {
    icon: AlertTriangle,
    title: "Something went wrong",
    description: "We couldn't load this data. Please try again.",
  },
};

/**
 * CustomEmptyState — "nothing here" / "no results" / "failed to load" block.
 *
 * Props:
 *  - type         "empty" (default) | "search" | "error"  → default icon + text
 *  - title, description   override the preset text
 *  - icon         any icon element (overrides the preset icon)
 *  - action       e.g. <CustomButton onClick={reload}>Retry</CustomButton>
 *  - compact      smaller padding, for use inside cards / table bodies
 *  - className, style
 */
const CustomEmptyState = ({
  type = "empty",
  title,
  description,
  icon,
  action,
  compact = false,
  className,
  style,
}) => {
  const preset = PRESETS[type] || PRESETS.empty;
  const PresetIcon = preset.icon;

  return (
    <div
      className={`ces-wrap ces-${type}${compact ? " ces-compact" : ""}${
        className ? ` ${className}` : ""
      }`}
      style={style}
      role={type === "error" ? "alert" : "status"}
    >
      <div className="ces-icon">{icon || <PresetIcon size={compact ? 22 : 26} />}</div>
      <div className="ces-title">{title ?? preset.title}</div>
      {(description ?? preset.description) && (
        <div className="ces-desc">{description ?? preset.description}</div>
      )}
      {action && <div className="ces-action">{action}</div>}
    </div>
  );
};

export default CustomEmptyState;
